import * as COMMON_STATICS from '../common'
import LogoHeader from './logo-header.png'

const BRAND_STATICS = {
  LOGO: LogoHeader,
  LOGO_HEADER: LogoHeader,
}

export const STATICS = {
  ...COMMON_STATICS,
  ...BRAND_STATICS,
}
